import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Toaster } from "react-hot-toast";

interface viewdata {
  sourceId: number;
  sourceName: string;
  isActive: boolean;
  createdBy: number;
  createdOn: string;
}

interface ViewMeadiaSourceCardProps {
  viewData: viewdata[];
  onEdit: (viewdata: viewdata) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const ViewMeadiaSourceCard: React.FC<ViewMeadiaSourceCardProps> = ({
  viewData,
  onEdit,
  onAddClick,
  showAddButton,
}) => {
  // State for clearing selected rows
  const [toggleCleared, setToggleCleared] = useState(false);

  // Handle edit button click
  const handleEditClick = (row: viewdata) => {
    onEdit(row);
  };

  // Handle row selection
  const handleRowSelected = (state: { selectedRows: viewdata[] }) => {
    console.log("Selected rows:", state.selectedRows);
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "Source Name",
      selector: (row: viewdata) => row.sourceName,
      sortable: true,
      cell: (row: viewdata) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.sourceName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.sourceName}
          </span>
        </div>
      ),
      width: "550px",
    },
    {
      name: "Status",
      selector: (row: viewdata) => row.isActive,
      sortable: true,
      cell: (row: viewdata) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "200px",
    },
    {
      name: "",
      cell: (row: viewdata) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Media Source"
            onClick={() => handleEditClick(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="action-button more-button" title="Replace Icon">
            <i className="bi bi-three-dots"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "100px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Media Source List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Media Source
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={viewData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No media sources found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{
            className: "custom-checkbox",
          }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
        />
      </div>
    </div>
  );
};

export default ViewMeadiaSourceCard;
